import service from "@/utils/request";

// 班级选择列表
export interface classSelectData {
  page?: number;
  page_size?: number;
  course_type?: number;
  name?: string;
}
export const classSelect = (params: classSelectData) => {
  return service({
    url: "/api/v1/class/select_list",
    method: "get",
    params,
  });
};

// 班级列表
export interface getClassListData {
  page?: number;
  page_size?: number;
  course_type?: number;
  name?: string;
  course_id?: number;
  teacher_id?: number;
  class_student_full?: number;
  completion_status?: number;
}
export const getClassList = (params: getClassListData) => {
  return service({
    url: "/api/v1/class/list",
    method: "get",
    params,
  });
};
// 班级统计
export const getClassCount = (params: getClassListData) => {
  return service({
    url: "/api/v1/class/count",
    method: "get",
    params,
  });
};

// 班级详情
export interface getClassDetailData {
  class_id: number;
}
export const getClassDetail = (params: getClassDetailData) => {
  return service({
    url: "/api/v1/class/detail",
    method: "get",
    params,
  });
};

// 添加班级
export interface createClassData {
  course_type: number;
  name: string;
  course_ids: number[];
  main_course_id: number;
  teacher_ids?: number[];
  preset_student_count?: number;
  student_excess: number;
  consume_number?: string;
  classroom_id?: number;
  remark?: string;
  student_id?: number;
}
export const createClass = (data: createClassData) => {
  return service({
    url: "/api/v1/class/add",
    method: "post",
    data,
  });
};

// 编辑班级
export interface editClassData {
  class_id: number;
  course_type: number;
  name: string;
  course_ids: number[];
  main_course_id: number;
  teacher_ids?: number[];
  preset_student_count?: number;
  student_excess?: number;
  consume_number?: string;
  classroom_id?: number;
  remark?: string;
  student_id?: number;
}
export const editClass = (data: editClassData) => {
  return service({
    url: "/api/v1/class/edit",
    method: "post",
    data,
  });
};

// 删除班级
export interface deleteClassData {
  class_ids: number[];
}
export const deleteClass = (data: deleteClassData) => {
  return service({
    url: "/api/v1/class/del",
    method: "post",
    data,
  });
};
// 班级结业
export interface completionClassData {
  class_ids: number[];
}
export const completionClass = (data: completionClassData) => {
  return service({
    url: "/api/v1/class/completion",
    method: "post",
    data,
  });
};

// 班级关联的课程列表
export interface getClassCourseListData {
  class_id: number;
}
export const getClassCourseList = (params: getClassCourseListData) => {
  return service({
    url: "/api/v1/class/course_list",
    method: "get",
    params,
  });
};

// 学员选择列表
export interface getStudentSelectListData {
  page?: number;
  page_size?: number;
  original_class_id?: number;
  lesson_id?: number;
  in_roll_call?: number;
  roll_call_id?: number;
  student_name?: string;
  course_id?: number;
  class_id?: number;
}
export const getStudentSelectList = (params: getStudentSelectListData) => {
  return service({
    url: "/api/v1/class/student/select_list",
    method: "get",
    params,
  });
};

// 学员列表
export interface getStudentListData {
  class_id: number;
}
export const getStudentList = (params: getStudentListData) => {
  return service({
    url: "/api/v1/class/student/list",
    method: "get",
    params,
  });
};

// 添加学员
export interface createStudentData {
  class_id: number;
  student_list: { student_id: number; course_id: number }[];
}
export const createStudent = (data: createStudentData) => {
  return service({
    url: "/api/v1/class/student/add",
    method: "post",
    data,
  });
};

// 删除学员
export interface deleteStudentData {
  class_id: number;
  student_ids: number[];
}
export const deleteStudent = (data: deleteStudentData) => {
  return service({
    url: "/api/v1/class/student/del",
    method: "post",
    data,
  });
};

// 学员可换班级列表
export interface studentCanJoinListData {
  original_class_id: number;
  course_id: number;
}
export const studentCanJoinList = (params: studentCanJoinListData) => {
  return service({
    url: "/api/v1/class/student/can_join_class_list",
    method: "get",
    params,
  });
};

// 学员换班
export interface studentChangeClassData {
  original_class_id: number;
  join_class_id: number;
  course_id: number;
  student_ids: number[];
}
export const studentChangeClass = (data: studentChangeClassData) => {
  return service({
    url: "/api/v1/class/student/change_class",
    method: "post",
    data,
  });
};

// 学员课程设置
export interface studentCourseSetData {
  class_id: number;
  course_id: number;
  student_id: number;
}
export const studentCourseSet = (data: studentCourseSetData) => {
  return service({
    url: "/api/v1/class/student/course_set",
    method: "post",
    data,
  });
};

// 学员课程所在的班级
export interface studentCourseRelateClassData {
  page: number;
  page_size: number;
  student_id: number;
  course_id: number;
  class_name?: string;
}
export const studentCourseRelateClassApi = (
  params: studentCourseRelateClassData
) => {
  return service({
    url: "/api/v1/student/course/class_list",
    method: "get",
    params,
  });
};
// 学员课程所在的班级
export interface studentExperienceData {
  page: number;
  page_size: number;
  key_word?: string;
  lesson_id?: number;
}
export const studentExperience = (params: studentExperienceData) => {
  return service({
    url: "/api/v1/class/student_experience/select_list",
    method: "get",
    params,
  });
};

// 课程科目
export const getCourseSubjectListApi = (params: any) => {
  return service({
    url: "/api/v1/subjects/org_subject_list",
    method: "get",
    params,
  });
};

// 课程类型
export const getCourseCategoryListApi = (params: any) => {
  return service({
    url: "/api/v1/course/course_category_list",
    method: "get",
    params,
  });
};

// 课程级别
export const getCourseLevelListApi = (params: any) => {
  return service({
    url: "/api/v1/course/course_level_list",
    method: "get",
    params,
  });
};

// 批量更改授课教师
export const multiChangeClassTeacherApi = (data: {
  class_ids: number[];
  original_teacher_id: number;
  target_teacher_id: number;
}) => {
  return service({
    url: "/api/v1/class/teacher_batch_change",
    method: "post",
    data,
  });
};
